__webpack_require__.p = "/ficha/";